import 'jquery-migrate';
import $ from 'jquery';
import Hubs from '../core';
import Shared from '../shared_util';
import MBP from '/app/libs/mbp/js/helper';

const HubsEmbed = {};

/** Make HubsEmbed global for inline JavaScript */
window.HubsEmbed = HubsEmbed;

/** Set window of Iframe as root */
HubsEmbed.root = window;

/**
 * HubsEmbed Core
 *
 * @class Core
 * @classdesc Application Controller
 * @namespace HubsEmbed
 * @return {Object} The Class Instance
 * @constructor
 */
HubsEmbed.Core = function(appOptions) {

    /* **************************************************************************************** */
    /* * Private Methods/Members Declarations                                                 * */
    /* **************************************************************************************** */
    var initialize = null,
        browserIdentifiers = null,
        optimizeMobile = null,
        updateServerUrls = null;


    /* **************************************************************************************** */
    /* * Public Properties                                                                    * */
    /* **************************************************************************************** */
    
    /** @member {Object} config A collection of configuration options for the current HubsEmbed instance  */
    this.config = null;
    

    /* **************************************************************************************** */
    /* * Private Methods/Members Definitions                                                  * */
    /* **************************************************************************************** */
    /**
     * Initialize the Application
     *
     * @private
     * @this HubsEmbed.Core
     * @return undefined
     * @constructs
     */
    initialize = $.proxy(function(options) {
        if (options === undefined) { return; }
        
        // Get Configuration Settings for Application
        this.config = $.extend(true, {}, Hubs.Config, options);
        
        // Breakout if mobile and in an iFrame asap
        if (window.top !== window.self) {
            if (Hubs.isMobile()) {
                window.top.location.href = window.self.location.href;
            } else {
                $('body').addClass('iframe');
            }
        }
        
        // Check for Admin Preview Mode
        if (/inPreview=1/i.test(window.location.search)) {
            $('body').addClass('inPreview');
        }
        
        // Update Logging/Profiling State
        Shared.Logger.enabled = this.config.enableDebugger;

        // Ensure Special Events are initialized; we need the debouncedresize event
        Hubs.initSpecialEvents();
        
        // Update Server URLs
        updateServerUrls();
        
        // Optimizations for Mobile Devices
        if (Hubs.isMobile()) { optimizeMobile(); }
        
        // Identify Browsers to CSS
        browserIdentifiers();
        
        // Prevent Errors
        if (!this.config.enableDebugger) {
            window.onerror = function() { return false; };
        }
    }, this);
    
    /**
     * Identify Browsers to CSS
     *     - Adds specific Classnames to the HTML tag
     * 
     * @private
     * @this Hubs.Core
     * @return undefined
     */
    browserIdentifiers = function() {
        // Check for IE10
        if (Hubs.MS_IE_10) { Shared.$('html').addClass('ie10'); }
        
        // Check for Android 3
        if (Hubs.ANDROID_3) { Shared.$('html').addClass('android3'); }
        
        // Check for Firefox in Android Tablets
        if (Hubs.ANDROID_FF) { Shared.$('html').addClass('android-ff'); }
        
        // Check for Amazon Kindle
        if (Hubs.AMAZON_SILK) { Shared.$('html').addClass('silk'); }
        
        // Check for BB Playbook 2.0
        if (Hubs.BB_PLAYBOOK) { Shared.$('html').addClass('playbook'); }
    };
    
    /**
     * Optimizations for Mobile Devices
     *     - Should only be called by Hubs.Core.initialize
     * 
     * @private
     * @this HubsEmbed.Core
     * @return undefined
     */
    optimizeMobile = function() {
        // Fix for iPhone viewport scale bug
        MBP.scaleFix();
        
        // Enable CSS active pseudo styles in Mobile Safari
        MBP.enableActive();
    };
    
    /**
     * Updates the Server URLs based on the Root URL supplied to Config
     * 
     * @private
     * @this HubsEmbed.Core
     * @return undefined
     */
    updateServerUrls = $.proxy(function() {
        this.config.serverUrl.cdn = this.config.filesUrl;
        this.config.serverUrl.hub = this.config.baseUrl + 'h/';
        this.config.serverUrl.initialLoad = this.config.baseUrl + 'hubsFront/embedded_loadInitial/';
        this.config.serverUrl.lazyLoader = this.config.baseUrl + 'hubsFront/embedded_loadItems/';
    }, this);


    /* **************************************************************************************** */
    /* * Entry Point                                                                          * */
    /* **************************************************************************************** */
    initialize(appOptions);
};
// End of HubsEmbed.Core


/* ******************************************************************************************** */
/* * Public Methods                                                                           * */
/* ******************************************************************************************** */

export default HubsEmbed;
